import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from '../../../../Shared/Tooltip'
import Loader from '../../../../Shared/Loader'

import TopDesignersTab from './TopDesignersTab'

class TopDesignersTabs extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: this.props.tabs[0].slug,
    }

    this.onTabClick = this.onTabClick.bind(this)
  }

  tabClassName(tabPanelComponentSlug) {
    return this.state.activeTab === tabPanelComponentSlug ? 'tab is-active' : 'tab'
  }

  onTabClick(slug) {
    this.setState({ activeTab: slug })
  }

  selectedData() {
    return this.props.data.filter((list) => list.type === this.state.activeTab)
  }

  render() {
    return (
      <div>
        <div className="tabs-container">
          <ul className="nav-tabs nav-tabs--small">
            {this.props.tabs.map((tab) => {
              return (
                <li key={tab.slug} className={this.tabClassName(tab.slug)}>
                  <a onClick={() => { this.onTabClick(tab.slug) }}>
                    <Tooltip
                      className="u-block"
                      tooltipClassName="tooltip--medium"
                      id={`dashboard__top-designers-tab--${tab.slug}`}
                      content={tab.text}
                    >
                      {tab.title}
                    </Tooltip>
                  </a>
                </li>
              )
            })}
          </ul>
        </div>

        <div className="tabs-content">
          <div className="tab-pane is-active">
            {!this.props.isDataFetched ? (
              <Loader />
            ) : (
              this.props.data.length === 0 ? (
                <div className="empty-content u-text-center">
                  <p>
                    Ooops! Something went wrong
                  </p>
                </div>
              ) : (
                <TopDesignersTab data={this.selectedData()} />
              )
            )}
          </div>
        </div>
      </div>
    )
  }
}

TopDesignersTabs.propTypes = {
  isDataFetched: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  tabs: PropTypes.array.isRequired,
}

export default TopDesignersTabs
